// Dependencies
require("webstrap/type");
require("grid");
require("element/rich-text");

// Styles
require("./faq.scss");

// JavaScript
var $ = require("jquery");

$('.sec-faq__wrap').each(function () {
    var $wrap = $(this),
        classe = 'sec-faq__wrap--open';

    $('.sec-faq__wrap-question', $wrap).on('click.faq', function (e) {
        if ($wrap.hasClass(classe)) {
            $wrap.removeClass(classe);
        } else {
            $wrap.addClass(classe);
        }
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/faq/index.js
 ** module id = 172
 ** module chunks = 0 1
 **/